<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <v-card-text>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">{{$t('work_center_editor.code')}}</span>
          </div>
          <input
            v-model="workCenter.code"
            type="text"
            :readonly="editing"
            class="form-control"
            aria-describedby="basic-addon1"
          />
        </div>

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              id="basic-addon1"
            >{{$t('work_center_editor.description')}}</span>
          </div>
          <input
            v-model="workCenter.description"
            type="text"
            class="form-control"
            aria-describedby="basic-addon1"
          />
        </div>
        <div class="form-check" v-if="editing">
          <input
            v-model="workCenter.deleted"
            class="form-check-input"
            type="checkbox"
            value
            id="deletedCheck"
          />
          <label class="form-check-label" for="deletedCheck">{{$t('work_center_editor.deleted')}}</label>
        </div>
        <div class="form-check" v-if="editing">
          <input
            v-model="workCenter.preperation"
            class="form-check-input"
            type="checkbox"
            value
            id="preperationCheck"
          />
          <label class="form-check-label" for="preperationCheck">{{$t('work_center_editor.preperation')}}</label>
        </div>
        <!-- This is where I add and remove dependencies -->
        <div class="dependencies-wrapper" v-if="editing">
          <span class="dependencies-header">{{$t('work_center_editor.depends_on')}}:</span>
          <div class="dependency-manager">
            <div class="dependency-adder">
              <div class="input-group">
                <select v-model="selectedWorkCenter" class="custom-select" id="inputGroupSelect04">
                  <option
                    v-for="(center, i) in availableWorkCenters"
                    :key="i"
                  >{{center.description}}</option>
                </select>
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="addDependency"
                  >{{$t('work_center_editor.add')}}</button>
                </div>
              </div>
            </div>

            <div class="dependency-list">
              <ul class="list-group">
                <li v-for="(dependency, i) in dependencies" :key="i" class="list-group-item">
                  {{dependency.work_center.description}}
                  <span class="remove-button">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          small
                          color="red"
                          v-on="on"
                          @click="deleteDependency(dependency)"
                        >close</v-icon>
                      </template>
                      <span>{{ $t("work_center_editor.delete") }}</span>
                    </v-tooltip>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="edit" v-if="editing">{{$t("work_center_editor.save")}}</v-btn>
        <v-btn color="primary" flat @click="save" v-else>{{$t("work_center_editor.save")}}</v-btn>
        <v-btn color="primary" flat @click="dialog = false">{{$t("work_center_editor.close")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkCenterDependency from "@/models/WorkCenterDependency.js";
import WorkCenter from "@/models/WorkCenter.js";
export default {
  data() {
    return {
      editing: false,
      dialog: false,
      workCenter: {},
      availableWorkCenters: [],
      selectedWorkCenter: {},
      dependencies: [],
      onKeyUp: (e) => {
        if (e.key === "Enter") {
          if (this.editing) {
            this.edit();
          } else {
            this.save();
          }
        }
        if (e.key === "Escape") {
          this.dialog = false;
        }
      },
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.keyUpHandler);
  },
  methods: {
    openCreate() {
      this.workCenter = {};
      this.editing = false;
      this.dialog = true;
    },

    openEdit(workCenter, workCenters) {
      this.editing = true;
      this.workCenter = workCenter;
      this.getAvailableWorkCenters(workCenter, workCenters);
      this.getDependencies(workCenter, workCenters);
      this.dialog = true;
    },

    async reloadInfo() {
      const workCenters = await WorkCenter.loadCenters();
      const workCenter = workCenters.find((workCenter) => {
        return this.workCenter.id === workCenter.id;
      });
      this.getAvailableWorkCenters(workCenter, workCenters);
      this.getDependencies(workCenter, workCenters);
      this.workCenter = workCenter;
    },
    /**
     * dont show already selected and same work centers to prevent mistakes
     * @param currentWorkCenter
     * @param workCenters
     */
    getAvailableWorkCenters(currentWorkCenter, workCenters) {
      this.availableWorkCenters = workCenters.filter((workCenter) => {
        if (workCenter.id === currentWorkCenter.id) {
          return false;
        }
        for (let dependency of currentWorkCenter.dependencies) {
          if (dependency.depends_on === workCenter.id) {
            return false;
          }
        }
        return true;
      });
    },
    getDependencies(workCenter, workCenters) {
      const dependencies = [];
      workCenter.dependencies.forEach((dependency) => {
        const correspondingWorkCenter = workCenters.find((workCenter) => {
          return workCenter.id === dependency.depends_on;
        });
        dependency.work_center = correspondingWorkCenter;
        dependencies.push(dependency);
      });
      this.dependencies = dependencies;
    },

    async save() {
      if (!this.workCenter.code || !this.workCenter.description) {
        alert(this.$t("work_center_editor.required_fields"));
        return;
      }
      await WorkCenter.create(this.workCenter);
      this.$emit("workCenterCreated");
    },

    async edit() {
      await this.workCenter.save();
      this.$emit("workCenterUpdated");
    },

    async addDependency() {
      const foundWorkCenter = this.availableWorkCenters.find((workCenter) => {
        return workCenter.description === this.selectedWorkCenter;
      });
      if (!foundWorkCenter) {
        return;
      }
      await WorkCenterDependency.create({
        work_center_id: this.workCenter.id,
        depends_on: foundWorkCenter.id,
      });
      this.reloadInfo();
    },

    async deleteDependency(dependency) {
      const confirmation = confirm(
        this.$t("work_center_editor.delete_confirm")
      );
      if (!confirmation) {
        return;
      }
      await dependency.remove();
      this.reloadInfo();
    },
  },
};
</script>

<style scoped>
.dependency-manager {
  min-height: 200px;
}
.dependencies-header {
  font-weight: bold;
  font-size: 20px;
}
.remove-button {
  position: absolute;
  right: 20px;
  cursor: pointer;
}
</style>